import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

interface SwipeCarouselProps {
  images: SwipeCarouselImagesProps[];
  height?: number;
  onClickImage?: (url: string) => void;
}

export interface SwipeCarouselImagesProps {
  url: string;
  src: string;
}

export default function SwipeCarousel({
  images,
  height = 300,
  onClickImage,
}: SwipeCarouselProps) {
  const handleClick = (url: string) => {
    if (typeof onClickImage === "function") {
      onClickImage(url);
    }
  };

  return (
    <Swiper
      modules={[Navigation, Pagination]}
      navigation={false}
      pagination={{ clickable: true }}
      spaceBetween={10}
      slidesPerView={1}
      loop
      style={{ width: "100%", height }}
    >
      {images.map((media, idx) => (
        <SwiperSlide key={idx}>
          <img
            src={media.url}
            onClick={() => handleClick(media.src)}
            alt=""
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              //borderRadius: "8px",
            }}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}
